const prefix =
  "https://raw.githubusercontent.com/O-dik90/Landing_page/master/src/assets/images/products/";

export default [
  {
    title: "TVC / Digital Video",
    description: "Create fresh television ads and digital videos for brands.",
    items: [
      {
        id: 1,
        image: `${prefix}digital_video/Confidence Premium Night.png`,
        name: "Confidence Premium Night",
        route: {
          title: "TVC _ CONFIDENCE PREMIUM NIGHT - THE EXPERT OF ADULT CAREitle",
          link: "https://www.youtube.com/watch?v=HvOmj1hXPGI",
        },
      },
      {
        id: 2,
        image: `${prefix}digital_video/KUNCIE 1.png`,
        name: "Kunchie",
        route: {
          title: "TEASER - DASAR MENULIS FIKSI CARA DEE LESTARI (KUNCIE)",
          link: "https://www.youtube.com/watch?v=1rqU81z7ixg",
        },
      },
      {
        id: 3,
        image: `${prefix}digital_video/Molto.png`,
        name: "GRAB x MOLTO",
        route: {
          title: "GRAB x MOLTO ANTI KUSUT SPRAY",
          link: "https://www.youtube.com/watch?v=_Q4XhUyfyII&t=9s",
        },
      },
      {
        id: 4,
        image: `${prefix}digital_video/Ntrl.png`,
        name: "GRAB x NTRL",
        route: {
          title: "GRAB x NTRL MODAL PERCAYA",
          link: "https://www.youtube.com/watch?v=mjCkVAh2-hg&t=2s",
        },
      },
      {
        id: 6,
        image: `${prefix}digital_video/Slank.png`,
        name: "GRAB x OVO (SLANK)",
        route: {
          title: "GRAB x OVO (SLANK)",
          link: "https://www.youtube.com/watch?v=Ir2qnqzdaWM",
        },
      },
      {
        id: 7,
        image: `${prefix}digital_video/PONGAH.png`,
        name: "INTRA JAHE WANGI",
        route: {
          title: "ADS _ INTRA JAHE WANGI - ONEPECKERSTUDIO 2021",
          link: "https://www.youtube.com/watch?v=5ywkAq1ArdQ",
        },
      },
    ],
  },
  {
    title: "Film / Web Series",
    description: "Films that are full of emotion and can leave an impression on the audience's.",
    items: [
      {
        id: 1,
        image: `${prefix}film_web_series/mimi_1.png`,
        name: "Mimi lan Mintuna",
        route: {
          title: "SHORTMOVIE _ MIMI LAN MINTUNA (CINTA TERHALANG WETON)",
          link: "https://www.youtube.com/watch?v=6lUBrKfPxoM&list=PLTzkaD-RIcdSHb8B_EJiV9y10CN-hnWCH",
        },
      },
      {
        id: 2,
        image: `${prefix}film_web_series/sepanjang_1.png`,
        name: "Sepanjang 2006",
        route: {
          title: "SHORTMOVIE _ SEPANJANG 2006 (GEMPA BUMI JOGJA-KLATEN TAHUN 2006)",
          link: "https://www.youtube.com/watch?v=ELp_i5JncUY",
        },
      },
      {
        id: 3,
        image: `${prefix}film_web_series/sepanjang_2.png`,
        name: "Trailer Sepanjang 2006",
        route: {
          title: "TRAILER _ SEPANJANG 2006",
          link: "https://www.youtube.com/watch?v=nXVPViA_n0Q&t=1s",
        },
      },
    ],
  },
  {
    title: "Infographic / Animation",
    description: "Create fun animations that everyone can enjoy.",
    items: [
      {
        id: 1,
        image: `${prefix}infographic/paddle pop 1.png`,
        name: "Paddle Pop",
        route: {
          title: "PADDLE POP SEAVENTURE 2021",
          link: "https://www.youtube.com/watch?v=8tgFbwV0Kkc&t=60s",
        },
      },
      {
        id: 2,
        image: `${prefix}infographic/DINKES.png`,
        name: "Dinas Kesehatan - TBC",
        route: {
          title: "VIDEO EDUKASI PENYAKIT TBC (TUBERKULOSIS) _ DINAS KESEHATAN KAB. KLATEN 2020",
          link: "https://www.youtube.com/watch?v=wrbhEPin4Fk",
        },
      },
      {
        id: 3,
        image: `${prefix}infographic/DINKES_1.png`,
        name: "Dinas Kesehatan - DBD",
        route: {
          title: "VIDEO EDUKASI DBD (DEMAM BERDARAH DENGUE) _ DINAS KESEHATAN KAB. KLATEN 2020",
          link: "https://www.youtube.com/watch?v=sK5-Uel1sl4&t=1s",
        },
      },
      {
        id: 4,
        image: `${prefix}infographic/A MILD - VR.png`,
        name: "A MILD",
        route: {
          title: "A MILD PIONER'S LINE 'Belanja Mudah Lewat VR'",
          link: "https://www.youtube.com/watch?v=WhjZp0_IqQY",
        },
      },
      {
        id: 5,
        image: `${prefix}infographic/A MILD - WEB.png`,
        name: "A MILD_1",
        route: {
          title: "A MILD PIONER'S LINE 'Ada Apa Dengan Web 3.0'",
          link: "https://www.youtube.com/watch?v=HUp0BcJRKP8&t=3s",
        },
      },
      {
        id: 6,
        image: `${prefix}infographic/BTN PRIORITAS - APRIL.png`,
        name: "BTN PRIORITAS_APRIL",
        route: {
          title: "MARKET BEAT_BTN PRIORITAS (EDISI APRIL 2023)",
          link: "https://www.youtube.com/watch?v=-6-gbGD0eFA&t=38s",
        },
      },
      {
        id: 7,
        image: `${prefix}infographic/BTN PRIORITAS - JUNI.png`,
        name: "BTN PRIORITAS_JUNI",
        route: {
          title: "MARKET BEAT_BTN PRIORITAS (EDISI JUNI 2023)",
          link: "https://www.youtube.com/watch?v=byCNG7NgZxM",
        },
      },
      {
        id: 8,
        image: `${prefix}infographic/BTN PRIORITAS - AGUSTUS.png`,
        name: "BTN PRIORITAS_AGUSTUS",
        route: {
          title: "MARKET BEAT_BTN PRIORITAS (EDISI AGUSTUS 2023)",
          link: "https://www.youtube.com/watch?v=P5l2xhuC0tA",
        },
      },
      {
        id: 9,
        image: `${prefix}infographic/BTN PRIORITAS - SEPTEMBER.png`,
        name: "BTN PRIORITAS_SEPTEMBER",
        route: {
          title: "MARKET BEAT_BTN PRIORITAS (EDISI SEPTEMBER 2023)",
          link: "https://www.youtube.com/watch?v=CyfFi8iwK2A",
        },
      },
    ],
  },
  {
    title: "Company Profile",
    description: "Wrapping the company to look strong and successful.",
    items: [
      {
        id: 1,
        image: `${prefix}company_profiles/NUTRIFEED.png`,
        name: "NUTRIFEED",
        route: {
          title: "EPS #1 - TESTIMONI PETERNAK _ COMPANY PROFILE NUTRIFEED",
          link: "https://www.youtube.com/watch?v=aJJh81ZQqts&t=143s",
        },
      },
      {
        id: 2,
        image: `${prefix}company_profiles/NUTRIFEED_2.png`,
        name: "NUTRIFEED",
        route: {
          title: "titEPS #7 - CARA MEMILIH SAPI BIBIT _ COMPANY PROFILE NUTRIFEEDle",
          link: "https://www.youtube.com/watch?v=s3eLxnsIAgo",
        },
      },
      {
        id: 3,
        image: `${prefix}company_profiles/TELKOM AKSES.png`,
        name: "TELKOM AKSES",
        route: {
          title: "FIBER ACADEMY - SALURAN PENANGGAL BAWAH TANAH (TELKOM AKSES)",
          link: "https://www.youtube.com/watch?v=OGtIN1z33VU",
        },
      },
    ],
  },
  {
    title: "Documentary",
    description: "Ready to take on history and travel the world.",
    items: [
      {
        id: 1,
        image: `${prefix}documentary/ledhek.png`,
        name: "Ledhek",
        route: {
          title: "DOCUMENTARY _ LEDHEK (PENARI TERAKHIR DI KLATEN)",
          link: "https://www.youtube.com/watch?v=dtrB1jgD1eU&t=8s",
        },
      },
      {
        id: 2,
        image: `${prefix}documentary/aqua.png`,
        name: "Aqua",
        route: {
          title: "DOC _ SUMBER RESAPAN AIR DARI HULU DESA MRIYAN BOYOLALI",
          link: "https://www.youtube.com/watch?v=Lg_owfzcnP0",
        },
      },
      {
        id: 3,
        image: `${prefix}documentary/TULUNGAGUNG.png`,
        name: "Penggerak #TETAPBELAJAR Kota Tulungagung",
        route: {
          title: " KISAH PENGGERAK #TETAPBELAJAR KOTA TULUNGAGUNG",
          link: "https://www.youtube.com/watch?v=WTURAD9O2nY",
        },
      },
      {
        id: 4,
        image: `${prefix}documentary/HIV.png`,
        name: "HIV",
        route: {
          title: "KISAH PARA ODHA DENGAN HIV/AIDS KAB. KLATEN",
          link: "https://www.youtube.com/watch?v=XatRcF8kKKQ&t=109s",
        },
      },
      {
        id: 5,
        image: `${prefix}documentary/BLITAR.png`,
        name: "Penggerak #TETAPBELAJAR Kota Blitar",
        route: {
          title: "KISAH PENGGERAK #TETAPBELAJAR KOTA BLITAR ",
          link: "https://www.youtube.com/watch?v=iUQBUJxR_ik&t=18s",
        },
      },
    ],
  },
  {
    title: "Music Video",
    description: "Help convey the song's message through the best visuals.",
    items: [
      {
        id: 1,
        image: `${prefix}music_video/DAMARA DE - TRESNOMU LUNGO.png`,
        name: "DAMARA DE - TRESNOMU LUNGO",
        route: {
          title: "DAMARA DE Ft SIXER MUSIC - TRESNOMU LUNGO ( COVER MUSIC VIDEO )",
          link: "https://www.youtube.com/watch?v=ykRUqSxu4O8",
        },
      },
      {
        id: 2,
        image: `${prefix}music_video/DAMARA DE - CRITO MUSTAHIL.png`,
        name: "DAMARA DE - CRITO MUSTAHIL",
        route: {
          title: "DAMARA DE Ft SIXER MUSIC - CRITO MUSTAHIL ( COVER MUSIK VIDEO )",
          link: "https://www.youtube.com/watch?v=1-mhAnm4LNM",
        },
      },
      {
        id: 3,
        image: `${prefix}music_video/nareswara.png`,
        name: "NARESWARA",
        route: {
          title: "TOMPONEN AKU OPO ANANE - NARESWARA (OFFICIAL MUSIC VIDOE)",
          link: "https://www.youtube.com/watch?v=4tsq1-_rnnY",
        },
      },
    ],
  },
];
